export type DashboardSectionScopeLabel = {
  label: string;
  tooltip?: string;
};

export type DashboardEventScopeDescription = {
  leadIn: string;
  sectionLabel: string;
  tooltip?: string;
};

export function formatDashboardSectionScopeLabel(sectionNames: string[]): DashboardSectionScopeLabel {
  const uniqueNames = [...new Set(sectionNames.filter(Boolean))];

  if (uniqueNames.length === 0) {
    return { label: "" };
  }

  if (uniqueNames.length === 1) {
    return { label: uniqueNames[0] };
  }

  if (uniqueNames.length === 2) {
    return { label: `${uniqueNames[0]} and ${uniqueNames[1]}` };
  }

  return {
    label: `${uniqueNames.length} sections you're associated with`,
    tooltip: uniqueNames.join(", ")
  };
}

export function getScheduleScopeDescription(sectionNames: string[]): DashboardEventScopeDescription | null {
  const { label, tooltip } = formatDashboardSectionScopeLabel(sectionNames);

  if (!label) {
    return null;
  }

  return {
    leadIn: "Upcoming events for",
    sectionLabel: label,
    tooltip
  };
}

export function getPastEventsScopeDescription(sectionNames: string[]): DashboardEventScopeDescription | null {
  const { label, tooltip } = formatDashboardSectionScopeLabel(sectionNames);

  if (!label) {
    return null;
  }

  return {
    leadIn: "Recently completed events for",
    sectionLabel: label,
    tooltip
  };
}

export function formatEventScopeDescriptionText(scope: DashboardEventScopeDescription): string {
  return `${scope.leadIn} ${scope.sectionLabel}`;
}
